import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getSpaPackageSeries = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/SpaPackageSeries/get`,
      filter,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching spa package series:", error);
    throw error;
  }
};

export const saveSpaPackageSeries = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/SpaPackageSeries/save`,
      data,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving spa package series:", error);
    throw error;
  }
};

export const checkSpaPackageSeriesBillingUsage = async (seriesId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/SpaPackageSeries/check-billing-usage`,
      seriesId,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error checking spa package series billing usage:", error);
    throw error;
  }
};

// API to export spa package series to Excel (Consolidated)
export const exportSpaPackageSeriesToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaPackageSeries/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SpaPackageSeriesReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting spa package series:", error);
    throw error;
  }
};

// API to export individual spa package series details to Excel
export const exportSpaPackageSeriesDetailsToExcel = async (seriesId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaPackageSeries/export-details-excel/${seriesId}`, {}, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SpaPackageSeriesDetails_${seriesId}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting spa package series details:", error);
    throw error;
  }
};